<template>
  <svg
    :viewBox="`0 0 ${svgWidth} ${svgHeight}`"
    xmlns="http://www.w3.org/2000/svg"
  >
    <use :xlink:href="`#svg__${icon}`" :fill="currentFill" />
  </svg>
</template>

<script>
export default {
  name: "SvgUse",
  props: ["icon", "size", "width", "height", "fill"],
  data() {
    return {};
  },
  computed: {
    currentFill() {
      return this.fill ? this.fill : "currentColor";
    },
    svgWidth() {
      return +this.width > 0 ? this.width : +this.size > 0 ? this.size : 14;
    },
    svgHeight() {
      return +this.height > 0 ? this.height : +this.size > 0 ? this.size : 14;
    }
  }
};
</script>

<style lang="css" scoped></style>
